import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';
import PATHS from 'utils/paths';

import { analysisChartsConfigRaw, chartsConfig } from '../../pages/Analysis/analysisWidgetsConfig';
import { dashboardChartsConfigRaw } from '../../pages/Dashboard/dashboardConfig';
import { homePageChartsConfigRaw } from '../../pages/Home/RecurringPage/homePageChartsConfig';
import Authorization from './Authorization';
import { WIDGET_SIZES } from './ManageWidgetsModal';

const WidgetWrapper = ({ widgetId, children }) => {
	const { pathname } = useLocation();
	const isMobile = useMediaQuery(Breakpoints.tablet);

	const data = useMemo(() => {
		if (pathname.startsWith(PATHS.HOME)) {
			return chartsConfig(homePageChartsConfigRaw);
		}
		if (pathname.startsWith(PATHS.ANALYSIS)) {
			return chartsConfig(analysisChartsConfigRaw);
		}
		if (pathname.startsWith(PATHS.DASHBOARD)) {
			return chartsConfig(dashboardChartsConfigRaw);
		}
	}, [pathname]);

	const getWidgets = useCallback(() => {
		const storedWidgets = localStorage.getItem(`${pathname}_new`);

		if (storedWidgets) {
			return JSON.parse(storedWidgets);
		}

		return data[`${pathname}_new`];
	}, [data, pathname]);

	const [widgets, setWidgets] = useState(getWidgets());

	const foundWidget = useMemo(() => widgets?.find((widget) => widget.id === widgetId), [widgets, widgetId]);

	const updateWidgetInfo = () => {
		setWidgets(getWidgets());
	};

	useEffect(() => {
		window.addEventListener('updateWidgetStore', updateWidgetInfo);

		return () => {
			window.removeEventListener('updateWidgetStore', updateWidgetInfo);
		};
	}, []);

	const calculatedStyle = useMemo(() => {
		if (isMobile) {
			return { flexGrow: 1, width: '100%', maxWidth: '100%' };
		}
		switch (foundWidget?.size) {
			case WIDGET_SIZES.small:
				return { flexGrow: 1, minWidth: '30%', maxWidth: '50%' };
			case WIDGET_SIZES.medium:
				return { flexGrow: 2, width: 'calc(50% - 2rem)', maxWidth: '50%' };
			case WIDGET_SIZES.large:
				return { flexGrow: 3, width: '100%' };
			default:
				return { flexGrow: 3, width: '100%' };
		}
	}, [isMobile, foundWidget?.size]);

	return (
		<Authorization path={foundWidget?.authorizationPath}>
			{foundWidget?.isVisible && (
				<div
					style={{
						order: foundWidget?.order,
						...calculatedStyle
					}}>
					{children}
				</div>
			)}
		</Authorization>
	);
};

export default WidgetWrapper;
